import React from 'react';
import { Typography, Button, makeStyles, Box, Link } from '@material-ui/core';
import { Link as RouterLink } from 'react-router-dom';
import transit from '../../assets/image/slick/ford-transit-desktop.webp';
import territory from '../../assets/image/slick/territory-desktop-tab.webp';
import explorer from '../../assets/image/slick/explorer-desktop-tab - Copy.webp';
import everest from '../../assets/image/slick/ford-everest-desktop - Copy.webp';
import ranger from '../../assets/image/slick/ford-ranger-stormtrak-desktop.webp';
import rapter from '../../assets/image/slick/raptor-desktop-tab - Copy.webp';
import territory2025 from '../../assets/image/slick/territory-tab-desktop.webp';
const useStyles = makeStyles((theme) => ({
    root: {
        position: 'relative', // Thiết lập container cha là relative
        width: '100%',
        // padding: theme.spacing(4),
        paddingTop: '24px',
        display: 'flex',
        flexDirection: 'column',
        alignItems: 'flex-start', // Căn trái nội dung văn bản và nút
    },
    imageContainer: {
        width: '100%',
        marginBottom: theme.spacing(2),
    },
    image: {
        display: 'block',
        width: '100%',
        height: 'auto',
        borderRadius: theme.shape.borderRadius,
    },
    overlay: {
        position: 'absolute', // Định vị tuyệt đối
        bottom: theme.spacing(10), // Cách đáy một khoảng
        left: theme.spacing(10), // Cách lề trái một khoảng
        color: 'white', // Màu chữ trắng
        padding: theme.spacing(2),
        zIndex: 1, // Đảm bảo overlay nằm trên ảnh
    },
    title: {
        marginBottom: theme.spacing(1),
    },
    buttonContainer: {
        display: 'flex',
        gap: theme.spacing(2),
    },
    exploreButton: {
        backgroundColor: theme.palette.primary.main,
        color: theme.palette.primary.contrastText,
        '&:hover': {
            backgroundColor: theme.palette.primary.dark,
        },
    },
    orderButton: {
        borderColor: theme.palette.primary.main,
        color: theme.palette.primary.main,
    },
}));

const VehicleContent = ({ selectedVehicle }) => {
    const classes = useStyles();

    const vehicleData = {
        Territory: {
            image: territory2025,
            title: 'Trọn vẹn từng khoảnh khắc',
            exploreText: 'Khám phá',
            linkUrl: '/suv/territory-new',
        },
        Everest: {
            image: everest,
            title: 'Làm chủ cuộc sống​',
            exploreText: 'Khám phá',
            linkUrl: '/suv/ford-everest',
        },
        Explorer: {
            image: explorer,
            title: 'Khơi dậy đam mê khám phá',
            exploreText: 'Khám phá',
            linkUrl: '/suv/ford-explorer',
        },
        Ranger: {
            image: ranger,
            title: 'Bản lĩnh vượt giới hạn',
            exploreText: 'Khám phá',
            linkUrl: '/trucks/ford-range',
        },  
        Transit: {
            image: transit,
            title: 'Tới Tương Lai',
            exploreText: 'Khám phá',
            linkUrl: '/trucks/ford-transit',
        },
        Mustang: {
            image: 'https://www.ford.com.vn/content/dam/Ford/vn/home/tabs/mustang-mach-e-tab-desktop.webp',
            title: 'Chỉ bạn có thể',
            exploreText: 'Khám phá',
            linkUrl: '/electric/ford-mustang-mach-e',
        },

    };

    const currentVehicle = vehicleData[selectedVehicle] || vehicleData.Raptor;

    return (
        <Box className={classes.root}>
            <div className={classes.imageContainer}>
                <img
                    src={currentVehicle.image}
                    alt={currentVehicle.title}
                    className={classes.image}
                />
            </div>
            <div className={classes.overlay}>
                <Typography variant="h3" className={classes.title}>
                    {currentVehicle.title}
                </Typography>
                <div className={classes.buttonContainer}>
                    <Link component={RouterLink} to={currentVehicle.linkUrl} underline="none">
                        <Button variant="contained" className={classes.exploreButton}>
                            {currentVehicle ? currentVehicle.exploreText : 'Xem thêm'}
                        </Button>
                    </Link>
                </div>
            </div>
        </Box>
    );
};

export default VehicleContent;